import { render, staticRenderFns } from "./couponDetail.vue?vue&type=template&id=44c24d4a&scoped=true"
import script from "./couponDetail.vue?vue&type=script&lang=js"
export * from "./couponDetail.vue?vue&type=script&lang=js"
import style0 from "./couponDetail.vue?vue&type=style&index=0&id=44c24d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c24d4a",
  null
  
)

export default component.exports